import { Component, OnInit, Output, EventEmitter, TemplateRef } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ContactsService } from '../../services/contacts.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { ContactsVm } from 'src/app/viewModels/core/contacts-vm';

import { MatDialog } from '@angular/material/dialog';





@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent implements OnInit {

  showdetail:boolean = true;
  addnewContact:boolean = false;
  showAddContact:boolean = false;
  addnewSharedContact:boolean = false;
  Module:string;


  panelOpenState: boolean = false;
  allExpandState: boolean =  false;

  value = '';
  addNew(){
    this.Module="Contact";
    this.showAddContact = !this.showAddContact;
  }
  getClose(message){
    this.showAddContact = message;
  }

  addContact(){
    this.addnewContact = !this.addnewContact;
  }

  addSharedContact(){
    this.addnewSharedContact = !this.addnewSharedContact;
  }
  

    

  @Output() showContactDetail = new EventEmitter<boolean>();
  currentUser: any;
  databaseId: string;
  organizationId: string;
  responseHolder: any;
  contactsList: any;

  constructor(private statusConst: StatusConstant, private loaderService: LoaderService,
    private contactsService: ContactsService, private toastr: ToastrService, private contactsVm: ContactsVm,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses, private dialog: MatDialog) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);

  }



  addShare(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
    });
  }
  close() {
    this.dialog.closeAll();
  }

  ngOnInit(): void {
    this.getContacts();
  }

  contactDetail(message:boolean){
      this.showContactDetail.emit(message);
  }
  getContacts() {
     
    this.contactsVm.DatabaseID = Number(this.databaseId);
    this.contactsVm.OrganizationID = Number(this.organizationId);
    this.contactsVm.UserID = this.currentUser.UID;
    this.loaderService.show();
    this.contactsService.getContacts(this.contactsVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactsList = response.data;
          this.loaderService.hide();
        }
      }
    });
  }




  peoples =[
    {
      name : 'Katina',
      email: 'Katina@gmail.com',
      img: 'Katina.jpg',       
    },
    {
      name : 'joyce',
      email: 'joyce@gmail.com',
      img: 'joyce.jpg',       
    },
    {
      name : 'Christy',
      email: 'Christy@gmail.com',
      img: 'Christy.jpg',       
    },
    {
      name : 'garry',
      email: 'garry@gmail.com',
      img: 'garry.jpg',       
    },
    {
      name : 'Barrera',
      email: 'Barrera@gmail.com',
      img: 'Barrera.jpg',       
    },
    
  ]


}
